<template>
  <!-- 网点信息 -->
  <el-tooltip class="item" effect="dark" placement="bottom">
    <div slot="content" class="detail-tip-view">
      <div>{{ $lang("异常类型") }}: {{ customerExcList.abnormalTypeName }}</div>
      <div>{{ $lang("问题描述") }}: {{ customerExcList.abnormalCauses }}</div>
      <template>
        <div>{{ $lang("应对话术") }}: {{ customerExcList.speechcraft }}</div>
        <div>{{ $lang("解决方案") }}: {{ customerExcList.solution }}</div>
        <div style="text-align: center"></div>
      </template>
    </div>
    <el-button
      v-show="
        waybillNo && !isEmptyObj(customerExcList) && customerExcList.abnormalTypeName
      "
      class="customer-type customer-type-customer"
      type="primary"
      >{{ (customerExcList.abnormalTypeName || "").substring(0, 5) }}</el-button
    >
  </el-tooltip>
</template>

<script>
import { isEmptyObj } from '@/common/utils/tool';
export default {
  name: 'DotInformation',
  props: {
    waybillNo: {
      type: String,
      default: ''
    },
    customerExcList: {
      type: Object,
      default: () => {
        return {
          abnormalTypeName: '',
          abnormalCauses: '',
          speechcraft: '',
          solution: ''
        };
      }
    }
  },
  data() {
    return {
      isEmptyObj
    };
  }
};
</script>

<style lang="scss" scoped>
.customer-type {
  position: absolute;
  left: -14px;
  top: 3px;
  font-weight: bolder;
  font-size: 16px;
  white-space: nowrap;
}
.customer-type-customer {
  top: -3px;
}
</style>
